/**
 * The seven entitlements, fixed.
 *
 * Sourced from `tracke5_ios/Domain/Entities/Premium.swift`. Do not add to this
 * list without a corresponding change there — entitlements are shared across
 * platforms, and RevenueCat is the common source of truth. Inventing a gate
 * name is a defect (CLAUDE.md); `entitlements.test.ts` guards it at runtime and
 * the union type below blocks it at compile time.
 *
 * There is no eighth for a read-only or trial state. The 7-day free window that
 * an earlier draft of Phase 1b modelled does not exist in either codebase — in
 * iOS it is a doc comment on `Premium.swift:28`, both gating call sites are a
 * plain binary `hasEntitlement` check, and the backend has no subscription
 * concept. See master PRD D11, revised.
 */
export const ENTITLEMENTS = [
  'unlimited_accounts',
  'cashflow_details',
  'ai_features',
  'spending_insights',
  'custom_categories',
  'custom_merchants',
  'export_data',
] as const

export type Entitlement = (typeof ENTITLEMENTS)[number]

/** Narrowing helper for values that arrive as strings — an API payload, a
 *  feature flag — where the compiler cannot help. */
export function isEntitlement(value: string): value is Entitlement {
  return (ENTITLEMENTS as readonly string[]).includes(value)
}
